import { DynamicPictogram } from '@/components/pictograms/DynamicPictogram'
import { Badge } from '@/components/shadcn/badge'
import { Link } from 'react-router'
import { ApplicationMarketingCard } from './selectFeaturedApps'

const TAG_VARIANT = {
  Live: 'success',
  Developing: 'warning',
  'Coming Soon': 'info',
} as const

export function FeaturedAppCard({ app }: { app: ApplicationMarketingCard }) {
  const title = app.card.title?.trim() ?? ''
  const subtitle = app.card.subtitle?.trim() ?? ''
  const showSubtitle = subtitle.length > 0 && subtitle !== title
  const tagVariant = TAG_VARIANT[app.tag as keyof typeof TAG_VARIANT] ?? 'outline'

  return (
    <Link to={`/featured-apps/${app.app_id}`} className="group block h-full">
      <article className="flex h-full flex-col items-center gap-4 rounded-xl border border-border bg-card p-8 text-center transition-colors group-hover:border-primary/40 group-hover:bg-muted/40">
        <DynamicPictogram gradient pictogramName={app.picture_url || 'PictogramCamera'} className="size-28" />
        <div className="flex flex-1 flex-col items-center gap-2">
          <h3 className="text-lg font-semibold text-card-foreground">{title}</h3>
          {showSubtitle && <p className="text-sm leading-relaxed text-muted-foreground">{subtitle}</p>}
        </div>
        <Badge variant={tagVariant} className="uppercase">
          {app.tag}
        </Badge>
      </article>
    </Link>
  )
}
